import { LinearProgress, Stack, Typography } from "@mui/material";
import { Header } from "./Header";
import { LoadingHeaderIcon } from "./HeaderIcon";

export const PaymentLoadingContent = ({
  icon,
  title,
  subtitle,
  body,
}: {
  icon: "card" | "arrow" | "lock";
  title: string;
  subtitle: string;
  body: string;
}) => (
  <Stack sx={{ gap: 2 }}>
    <Header
      icon={<LoadingHeaderIcon icon={icon} />}
      title={title}
      subtitle={subtitle}
    />
    <Typography variant="body1">{body}</Typography>
    <LinearProgress sx={{ borderRadius: 6, height: 6, mt: 3 }} />
  </Stack>
);
